import React, { FunctionComponent } from 'react';
import PostMandatoryQuestionsExperimentWrapper from '../../components/PostMandatoryQuestionsExperimentWrapper/PostMandatoryQuestionsExperimentWrapper';
import { connectPage } from '../connectPage';
import Page from '../Page';

interface OrganizerQuestionsPageCheckerProps {
    isOrganizerQuestionsPage: boolean;
}

const OrganizerQuestionsPageChecker: FunctionComponent<
    OrganizerQuestionsPageCheckerProps
> = (props) => {
    const { isOrganizerQuestionsPage, ...otherProps } = props;
    const ConnectedPage = connectPage(Page);

    const renderNode = isOrganizerQuestionsPage ? (
        <PostMandatoryQuestionsExperimentWrapper
            getComponent={(isPostPaymentQuestionsExperiment) => (
                <ConnectedPage
                    isOrganizerQuestionsPage={isOrganizerQuestionsPage}
                    isPostPaymentQuestionsExperiment={
                        isPostPaymentQuestionsExperiment
                    }
                    {...otherProps}
                />
            )}
        />
    ) : (
        <ConnectedPage
            isOrganizerQuestionsPage={isOrganizerQuestionsPage}
            isPostPaymentQuestionsExperiment={false}
            {...otherProps}
        />
    );

    return renderNode;
};

export default OrganizerQuestionsPageChecker;
